// Mirrors backend2/utils/districtAliases.js (same spelling -> canonical map) so district pickers
// list each district once (Trivandrum / Thiruvananthapuram are the same district).
const ALIASES = {
  thiruvananthapuram: 'Thiruvananthapuram', trivandrum: 'Thiruvananthapuram', trivandram: 'Thiruvananthapuram', tvm: 'Thiruvananthapuram',
  kollam: 'Kollam', quilon: 'Kollam',
  pathanamthitta: 'Pathanamthitta',
  alappuzha: 'Alappuzha', alleppey: 'Alappuzha',
  kottayam: 'Kottayam', idukki: 'Idukki',
  ernakulam: 'Ernakulam', cochin: 'Ernakulam', kochi: 'Ernakulam',
  thrissur: 'Thrissur', trichur: 'Thrissur',
  palakkad: 'Palakkad', palghat: 'Palakkad',
  malappuram: 'Malappuram',
  kozhikode: 'Kozhikode', calicut: 'Kozhikode',
  wayanad: 'Wayanad', wynad: 'Wayanad',
  kannur: 'Kannur', cannanore: 'Kannur',
  kasaragod: 'Kasaragod', kasargod: 'Kasaragod', kasarkode: 'Kasaragod',
};

export const canonicalDistrict = (name) => {
  const t = String(name || '').trim().replace(/\s+/g, ' ');
  return t ? ALIASES[t.toLowerCase()] || t : '';
};

/** [{ name: canonical, ids: [every District _id of that district] }], sorted by name. */
export const groupDistricts = (districts) => {
  const map = new Map();
  (districts || []).forEach((d) => {
    const name = canonicalDistrict(d.districtName || d.name);
    if (!name) return;
    if (!map.has(name)) map.set(name, { name, ids: [] });
    map.get(name).ids.push(d._id);
  });
  return [...map.values()].sort((a, b) => a.name.localeCompare(b.name));
};
